import {Component, inject, Input, OnDestroy, OnInit} from "@angular/core";
import {FormBuilder, Validators} from "@angular/forms";
import {selectFundValuationDescription} from "../../store/fund-valuation/fund-valuation.selectors";
import {map, Subscription} from "rxjs";
import {Store} from "@ngrx/store";
import {FundValuationActions} from "../../store/fund.actions";

@Component({
    selector: "valumize-fund-valuation-description-dialog",
    templateUrl: "./fund-valuation-description-dialog.component.html",
    styleUrl: "./fund-valuation-description-dialog.component.scss",
    standalone: false
})
export class FundValuationDescriptionDialogComponent implements OnInit, OnDestroy {
    private readonly store = inject(Store);
    private readonly formBuilder = inject(FormBuilder);

    @Input() fundId?: number;
    @Input() fundReportId?: number;

    subscriptions: Subscription[] = [];

    constructor( ) {
    }

    fundValuationDescriptionForm = this.formBuilder.group({
        description: this.formBuilder.control("", {nonNullable: true, validators: [Validators.required, Validators.maxLength(30)]})
    })

    ngOnInit() {
        this.subscriptions.push(
            this.store.select(selectFundValuationDescription).pipe(map((description) => {
                this.fundValuationDescriptionForm.patchValue({
                    description: description.text
                });
            })).subscribe());
    }

    ngOnDestroy = () => this.subscriptions.forEach(subscription => subscription.unsubscribe());

    saveFundValuationDescription() {
        if (this.fundValuationDescriptionForm.valid && this.fundId && this.fundReportId) {
            this.store.dispatch(FundValuationActions.saveDescription({
                fundId: this.fundId,
                fundReportId: this.fundReportId,
                description: this.fundValuationDescriptionForm.getRawValue().description
            }));
        }
    }
}
